export default __webpack_public_path__ + "static/m-dedicated-672de79b4915f6b25dc08b61cbc2c314.jpg";